var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarRoyalBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 25C9.79469 25 6.78119 23.7518 4.51469 21.4853C2.24819 19.2188 1 16.2053 1 13C1 9.79469 2.24823 6.78123 4.51469 4.51469C6.78114 2.24814 9.79469 1 13 1C16.2053 1 19.2188 2.24819 21.4853 4.51469C23.7518 6.78119 25 9.79469 25 13C25 16.2053 23.7518 19.2188 21.4853 21.4853C19.2189 23.7519 16.2053 25 13 25ZM13 2.5C7.21028 2.5 2.5 7.21028 2.5 13C2.5 18.7897 7.21028 23.5 13 23.5C18.7897 23.5 23.5 18.7897 23.5 13C23.5 7.21028 18.7897 2.5 13 2.5Z",
    fill: "#556BB8",
    stroke: "#556BB8",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.25C11.9661 12.25 11.125 11.4089 11.125 10.375C11.125 9.34113 11.9661 8.5 13 8.5C14.0339 8.5 14.875 9.34113 14.875 10.375C14.875 10.7892 15.2108 11.125 15.625 11.125C16.0392 11.125 16.375 10.7892 16.375 10.375C16.375 8.77183 15.251 7.42712 13.75 7.08503V6.25C13.75 5.83581 13.4142 5.5 13 5.5C12.5858 5.5 12.25 5.83581 12.25 6.25V7.08503C10.749 7.42712 9.625 8.77183 9.625 10.375C9.625 12.236 11.139 13.75 13 13.75C14.0339 13.75 14.875 14.5911 14.875 15.625C14.875 16.6589 14.0339 17.5 13 17.5C11.9661 17.5 11.125 16.6589 11.125 15.625C11.125 15.2108 10.7892 14.875 10.375 14.875C9.96077 14.875 9.625 15.2108 9.625 15.625C9.625 17.2282 10.749 18.5729 12.25 18.915V19.75C12.25 20.1642 12.5858 20.5 13 20.5C13.4142 20.5 13.75 20.1642 13.75 19.75V18.915C15.251 18.5729 16.375 17.2282 16.375 15.625C16.375 13.764 14.861 12.25 13 12.25Z",
    fill: "#556BB8",
    stroke: "#556BB8",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarRoyalBlue);
export default __webpack_public_path__ + "static/media/dollar-royal-blue.411afe7e34b0f0224fe8b7a711850afd.svg";
export { ForwardRef as ReactComponent };